<div>
  <!-- <app-loader *ngIf="loading"></app-loader> -->
  <div class="dis-flex flex-sb-m">
    <div>
      <h1 class="font-medium m-b-0" *ngIf="this.category != 'affiliate'" ngbTooltip="Short Term Outcomes">{{ title }} STO </h1>
      <h1 class="font-medium m-b-0" *ngIf="this.category == 'affiliate'" ngbTooltip="Medium Term Outcomes">{{ title }} MTO</h1>
    </div>
    
    <div class="dis-flex">
      <div class="m-r-20">
        <p class="item-title text-left m-b-0 b2 font-medium text-80">
          {{ "Year" }}
        </p>
        <p-dropdown
          id="dropdown"
          name="theme_id"
          [options]="outcomeYear"
          placeholder="Select Year"
          [(ngModel)]="currentYear"
          filterPlaceholder="Search"
          [showClear]="false"
          optionLabel="value"
          optionValue="value"
          (onChange)="onHomeYearChange($event)"
          [overlayOptions]="helper.getOverlayOptions()"
        >
        </p-dropdown>
      </div>
      <div class="dis-flex flex-column m-r-20" *ngIf="this.category != 'affiliate'">
        <label class="b2 font-medium text-80">Cycle</label>
        <p-dropdown
          class="count-popup-filter"
          [options]="quarter"
          optionLabel="quarterVal"
          [(ngModel)]="currentQuater"
          optionValue="quarter"
          (onChange)="onQuarterFilterChange($event.value)"
          placeholder="Select Quarter"
        />
      </div>
      <div class="dis-flex flex-column">
        <label class="b2 font-medium text-80">Business Theme</label>
        <!-- <p-dropdown
          class="count-popup-filter"
          [options]="businessThemeLists"
          optionLabel="value"
          optionValue="key"
          placeholder="All"
          filter="true"
          filterPlaceholder="Search"
          [showClear]="true"
          [(ngModel)]="currentTheme"
          placeholder="All"
          [overlayOptions]="helper.getOverlayOptions()"
          (onChange)="onThemeFilterChange($event.value)"
        /> -->
      

        <p-dropdown
        id="dropdown"
        name="theme_id"
        optionValue="theme_id"
        [options]="businessThemeLists"
        placeholder="Select an Option"
        filter="true"
        [(ngModel)]="currentTheme"
        filterPlaceholder="Search"
        [showClear]="true"
        optionLabel="value"
        (onChange)="onThemeFilterChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
      </div>
     
    </div>
  </div>
  <div class="quarterly-outcome-list m-t-20" *ngIf="this.category != 'affiliate'">
    <div #scrollContainer class="outer-container">
      <div class="outcome-card w-full" *ngIf="!loading; else ShimmerEffect">
        <app-virtual-scroll
          class="w-full"
          [data]="listPayloadData"
          [apiUrl]="outcomesListUrl"
          (loadedData)="onDataLoaded($event)"
        >
          <ng-container *ngIf="outcomesList?.length; else noDataFound">
            <div *ngFor="let item of outcomesList">
              <app-quarterly-outcome-list
                [outcomesData]="item"
              ></app-quarterly-outcome-list>
            </div>
          </ng-container>
        </app-virtual-scroll>
      </div>

      <!-- <div *ngIf="loading" class="loading">Loading more data...</div> -->
    </div>
    <!-- <p-scroller 
      [items]="outcomesList" 
      [itemSize]="50" 
      scrollHeight="400px" 
      styleClass="border-1 surface-border" 
      [style]="{'width':'100%','height': '600px'}" (onScroll)="onScroll($event)">
        <ng-template pTemplate="item" let-item let-i="index" let-options="options">
          <h1>{{ i + 1 }} -- {{ item.value }}</h1>
          <app-quarterly-outcome-list  [outcomesData]="item"></app-quarterly-outcome-list>
        </ng-template>
      </p-scroller>
      </ng-container>
      <ng-template #elseBlock>
        <div>No data available</div>
      </ng-template> -->
  </div>

  <div class="quarterly-outcome-list m-t-20" *ngIf="this.category == 'affiliate'">
    <div #scrollContainer class="outer-container">
      <div class="outcome-card w-full" *ngIf="!loading; else ShimmerEffect">
        <app-virtual-scroll
          class="w-full"
          [data]="listPayloadData"
          [apiUrl]="outcomesListUrl"
          (loadedData)="onDataLoaded($event)"
        >
          <ng-container *ngIf="outcomesList?.length; else noDataFound">
            <div *ngFor="let item of outcomesList">
              <app-annual-outcome-list
                [outcomesData]="item"
                [isAffiliate]="this.category=='affiliate' ? true : false"
              ></app-annual-outcome-list>
            </div>
          </ng-container>
        </app-virtual-scroll>
      </div>
    </div>
  </div>
</div>

<ng-template #ShimmerEffect>
  <app-shimmer-list></app-shimmer-list>
</ng-template>

<ng-template #noDataFound>
  <app-no-data-found></app-no-data-found>
</ng-template>
